import { useAmpliFeatureFlags } from '@tackle-io/tackle-auth-tools';
import { FeatureFlagState } from 'packages/cosell/src/types/enums/FeatureFlags';
const POLLING_FEATURE_FLAG = 'sfdc-co-sell-tackle-widget-polling-enabled';

/**
 * checks amplitude feature flags to determine if
 * polling should be enabled for the tackle widget co-sell tab
 */
export default function useSfdcTackleWidgetPollingEnabled() {
  const { flags } = useAmpliFeatureFlags();
  return flags[POLLING_FEATURE_FLAG] === FeatureFlagState.ON;
}
